export const getModifiersIds = modifierGroups => {
  const modifierIds = modifierGroups.flatMap(modifierGroup => (modifierGroup.modifiers || []).map(modifier => modifier.id)).filter(Boolean);
  const modifierIdsWithoutDuplicates = new Set(modifierIds);
  return [...modifierIdsWithoutDuplicates];
};
export const createDisplayedModifiers = (modifiers, modifiersMap) => {
  return modifiers.map(modifier => {
    const modifierDTO = modifiersMap[modifier.id];
    return modifierDTO ? {
      id: modifier.id,
      revision: modifierDTO.revision,
      additionalChargeInfo: modifier.additionalChargeInfo,
      name: modifierDTO.name,
      preSelected: modifier.preSelected,
      inStock: modifierDTO.inStock ?? true,
      externalReferenceInfo: modifierDTO.externalReferenceInfo
    } : undefined;
  }).filter(modifier => modifier !== undefined);
};
export const cleanDoubleAndTrailingSpace = modifierName => modifierName.replace(/\s+/g, ' ').trim();
//# sourceMappingURL=modifiers.js.map